import React from 'react';
import { Button, Container, Table } from 'semantic-ui-react';
import tags from './tags';

const Help = props => (
    <Container>
        <Table celled collapsing>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell content='Name' />
                    <Table.HeaderCell content='Tag' />
                    <Table.HeaderCell content='Example' />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {tags.map(([name, tag, example]) => (
                    <Table.Row>
                        <Table.Cell content={name} />
                        <Table.Cell content={tag} />
                        <Table.Cell content={example} />
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>

        <Button onClick={() => props.history.push('/documents')}> Back to Documents Page </Button>
    </Container>
);

export default Help;
